export const getClientAuthHeader = () => {
    let token = window.localStorage.getItem('token');
    let config = {};
    if (token) {
        config = {
            headers: {
                'x-access-token': token
            }
        };
    }

    return config;
}

export const getClientAuthToken = () => {
    let token = window.localStorage.getItem('token');
    return token;
}

export const setClientToken = (token) => {
    // Keep the stashed admin token across token swaps so an admin who is
    // impersonating a user can always return to their own session.
    let adminToken = window.localStorage.getItem(ADMIN_TOKEN_KEY);
    window.localStorage.clear()
    window.localStorage.setItem('token', token);
    if (adminToken) {
        window.localStorage.setItem(ADMIN_TOKEN_KEY, adminToken);
    }
}

export const clearClientToken = (token) => {
    window.localStorage.clear();
}

//
// Admin impersonation. While the admin impersonates a user, the app runs on
// the impersonated user's JWT and the admin's own JWT is stashed under
// ADMIN_TOKEN_KEY so the session can be restored without logging in again.
//

const ADMIN_TOKEN_KEY = 'adminToken';

export const beginImpersonation = (impersonatedToken) => {
    // Only stash the admin token once — switching directly from one
    // impersonated user to another must not overwrite it.
    if (!window.localStorage.getItem(ADMIN_TOKEN_KEY)) {
        window.localStorage.setItem(ADMIN_TOKEN_KEY, window.localStorage.getItem('token'));
    }

    setClientToken(impersonatedToken);
}

export const endImpersonation = () => {
    let adminToken = window.localStorage.getItem(ADMIN_TOKEN_KEY);
    if (adminToken) {
        setClientToken(adminToken);
    }

    window.localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export const isImpersonating = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    let adminToken = window.localStorage.getItem(ADMIN_TOKEN_KEY);
    let token = window.localStorage.getItem('token');
    return Boolean(adminToken && token && adminToken !== token);
}

// Auth header built from the stashed ADMIN token (not the impersonated
// user's) — used by the impersonation banner to list/switch users.
export const getAdminAuthHeader = () => {
    let adminToken = window.localStorage.getItem(ADMIN_TOKEN_KEY);
    if (!adminToken) {
        return getClientAuthHeader();
    }

    return {
        headers: {
            'x-access-token': adminToken
        }
    };
}

export const isAuthenticated = () => {
    let token = window.localStorage.getItem('token');
    if (token) {
        return true;

    } else {
        return false;
    }
}